module.exports = __webpack_public_path__ + "img/DNRIL-Color-Horiz.d4f3a4c2.png";